module.exports = __webpack_public_path__ + "fonts/creditu-icons.ebf19d35.ttf";